<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-lg-2 col-xl-3"></div>
    <div class="col-lg-8 col-xl-6">
      <div class="card mb-3">
        <form [formGroup]="userForm" (ngSubmit)="updateUser()">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'user']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ 'label.mina-uppgifter-hos-instans' | translate:{ instans: instanceName } }}
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">

                <div class="form-group">
                  <label for="personal_number">{{ 'label.personnr' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'passport']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="personal_number" id="personal_number" class="form-control" [attr.placeholder]="'placeholder.personnr' | translate" formControlName="personal_number">
                  </div>
                </div>

                <div class="form-group">
                  <label for="first_name">{{ 'label.fornamn' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'font']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="first_name" id="first_name" class="form-control rounded-right" [attr.placeholder]="'placeholder.fornamn' | translate" required formControlName="first_name" [class.is-invalid]="first_name.invalid">
                    <div class="invalid-tooltip">{{ 'label.faltet-far-inte-lamnas-tomt' | translate }}</div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="last_name">{{ 'label.efternamn' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'font']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="last_name" id="last_name" class="form-control rounded-right" [attr.placeholder]="'placeholder.efternamn' | translate" required formControlName="last_name" [class.is-invalid]="last_name.invalid">
                    <div class="invalid-tooltip">{{ 'label.faltet-far-inte-lamnas-tomt' | translate }}</div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="phone">{{ 'label.telefonnr' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'phone']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="phone" id="phone" class="form-control rounded-right" [attr.placeholder]="'placeholder.telefonnr' | translate" formControlName="phone" [class.is-invalid]="phone.invalid">
                    <div class="invalid-tooltip">{{ 'label.ogiltigt-telefonnr' | translate }}</div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="email">{{ 'label.epost' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'at']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="email" id="email" class="form-control rounded-right" [attr.placeholder]="'placeholder.epost' | translate" formControlName="email" [class.is-invalid]="email.invalid">
                    <div class="invalid-tooltip">{{ 'label.ogiltig-epost' | translate }}</div>
                  </div>
                </div>

              </div>
              <div class="col-sm-6">

                <div class="form-group">
                  <label for="street1">{{ 'label.postadress' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'address-book']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="street1" id="street1" class="form-control rounded-right" [attr.placeholder]="'placeholder.postadress' | translate" formControlName="street1" [class.is-invalid]="street1.invalid">
                    <div class="invalid-tooltip">{{ 'label.faltet-far-inte-lamnas-tomt' | translate }}</div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="street2">{{ 'label.care-of' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'address-book']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="street2" id="street2" class="form-control" [attr.placeholder]="'placeholder.care-of' | translate" formControlName="street2">
                  </div>
                </div>

                <div class="form-group">
                  <label for="postal_code">{{ 'label.postnr' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'city']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="postal_code" id="postal_code" class="form-control rounded-right" [attr.placeholder]="'placeholder.postnr' | translate" formControlName="postal_code" [class.is-invalid]="postal_code.invalid">
                    <div class="invalid-tooltip">{{ 'label.ogiltigt-postnr' | translate }}</div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="city">{{ 'label.postort' | translate }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'city']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                      </span>
                    </div>
                    <input type="text" name="city" id="city" class="form-control rounded-right" placeholder="Postort" formControlName="city" [class.is-invalid]="city.invalid">
                    <div class="invalid-tooltip">{{ 'label.faltet-far-inte-lamnas-tomt' | translate }}</div>
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="account_type">{{ 'label.kontouppgifter' | translate }}</label>
                  <div class="input-group">
                    <div class="radio btn-group w-100">
                      <label for="account_type_svenskt" class="btn btn-pink mb-0" [class.active]="account_type.value==='sv'">
                        <input type="radio" name="account_type" id="account_type_svenskt" value="sv" formControlName="account_type" (change)="updateRequiredFields()">{{ 'label.svenskt-konto' | translate }}
                      </label>
                      <label for="account_type_utlandskt" class="btn btn-pink mb-0" [class.active]="account_type.value==='iban'">
                        <input type="radio" name="account_type" id="account_type_utlandskt" value="iban" formControlName="account_type" (change)="updateRequiredFields()">{{ 'label.utlandskt-konto' | translate }}
                      </label>
                      <label for="account_type_nul" class="btn btn-pink mb-0" [class.active]="account_type.value==='nul'">
                        <input type="radio" name="account_type" id="account_type_nul" value="nul" formControlName="account_type" (change)="updateRequiredFields()">{{ 'label.konto-saknas' | translate }}
                      </label>
                    </div>
                    <div class="invalid-tooltip">{{ 'label.du-maste-valja-kontotyp' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" [ngSwitch]="account_type.value">
              <ng-container *ngSwitchCase="'sv'">
                <div class="col-sm-6">

                  <div class="form-group">
                    <label for="clearing_code">{{ 'label.clearingnr' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <fa-icon [icon]="['fas', 'credit-card']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                        </span>
                      </div>
                      <input type="text" name="clearing_code" id="clearing_code" class="form-control rounded-right" [attr.placeholder]="'placeholder.clearingnr' | translate" formControlName="clearing_code" [class.is-invalid]="clearing_code.invalid">
                      <div class="invalid-tooltip">{{ 'label.ogiltigt-clearingnr' | translate }}</div>
                    </div>
                  </div>

                </div>
                <div class="col-sm-6">

                  <div class="form-group">
                    <label for="account_number">{{ 'label.kontonr' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <fa-icon [icon]="['fas', 'credit-card']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                        </span>
                      </div>
                      <input type="text" name="account_number" id="account_number" class="form-control rounded-right" placeholder="{{ 'placeholder.kontonr' | translate }}" formControlName="account_number" [class.is-invalid]="account_number.invalid">
                      <div class="invalid-tooltip">{{ 'label.ogiltigt-kontonr' | translate }}</div>
                    </div>
                  </div>

                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'iban'">
                <div class="col-sm-6">

                  <div class="form-group">
                    <label for="iban_number">{{ 'label.iban' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <fa-icon [icon]="['fas', 'credit-card']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                        </span>
                      </div>
                      <input type="text" name="iban_number" id="iban_number" class="form-control rounded-right" [attr.placeholder]="'placeholder.iban' | translate" formControlName="iban_number" [class.is-invalid]="iban_number.invalid">
                      <div class="invalid-tooltip">{{ 'label.ogiltigt-iban' | translate }}</div>
                    </div>
                  </div>

                </div>
                <div class="col-sm-6">

                  <div class="form-group">
                    <label for="bic_code">{{ 'label.bic' | translate }}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <fa-icon [icon]="['fas', 'credit-card']" transform="grow-6" [fixedWidth]="true"></fa-icon>
                        </span>
                      </div>
                      <input type="text" name="bic_code" id="bic_code" class="form-control rounded-right" [attr.placeholder]="'placeholder.bic' | translate" formControlName="bic_code" [class.is-invalid]="bic_code.invalid">
                      <div class="invalid-tooltip">{{ 'label.ogiltig-bic' | translate }}</div>
                    </div>
                  </div>

                </div>
              </ng-container>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="message-text">{{ 'label.anledning-till-andrade-uppgifter' | translate }}</label>
                  <div class="input-group">
                    <textarea class="form-control" rows="5" [attr.placeholder]="'placeholder.message' | translate" id="message-text" name="message-text" formControlName="message_text"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row justify-content-end">
              <button type="submit" class="btn-garanti btn-pink mb-0" [disabled]="userForm.invalid || !userForm.dirty" [title]="'label.klicka-for-att-spara' | translate">{{ 'button.spara' | translate }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
